import { useEffect, useRef } from 'react';
import { useStore } from '@core/widgets/store';
import { useEmbedFeedStore } from '../embedFeed/store';
export const WATCH_THRESHOLD = 3000;
export const WATCH_THRESHOLD_V2 = 10000;
/**
 * Toggles a user's engagement to true based on the carousel video being in an interactable state
 * for a min of 3s and tracks additional engagement at 10s.
 *
 * Once the engaged state is set to true, it will not get set back to false. State only resets to false
 * when carousel video is updated to another video in the carousel.
 *
 * This is currently only used for Player Deck widget via isPlayerDeckEmbed
 * param
 */
export function useHandleEmbedEngagedVideo({ isPlayerDeckEmbed, appContext, }) {
    const engagedVideoId = useStore((store) => store.engagedVideoId);
    const storeActions = useStore((state) => state.actions);
    const isInteractable = isPlayerDeckEmbed;
    const autoPlayId = useEmbedFeedStore((state) => state.autoplayId);
    const interactionTimeout = useRef(null);
    const interactionTimeoutV2 = useRef(null);
    useEffect(() => {
        if (isInteractable && autoPlayId !== engagedVideoId && engagedVideoId) {
            storeActions.setEngagedVideo(null);
            storeActions.setEngagedVideoV2(null);
        }
    }, [isInteractable, autoPlayId, engagedVideoId, storeActions]);
    useEffect(() => {
        // Only set up new tracking if conditions are met
        if (isInteractable && autoPlayId) {
            interactionTimeout.current = setTimeout(() => {
                storeActions.setEngagedVideo(autoPlayId);
            }, WATCH_THRESHOLD);
            interactionTimeoutV2.current = setTimeout(() => {
                storeActions.setEngagedVideoV2(autoPlayId);
            }, WATCH_THRESHOLD_V2);
        }
        return () => {
            if (interactionTimeout.current) {
                clearTimeout(interactionTimeout.current);
            }
            if (interactionTimeoutV2.current) {
                clearTimeout(interactionTimeoutV2.current);
            }
        };
    }, [isInteractable, autoPlayId, storeActions, appContext]);
}
